import { OrderLanguageMap, OrderI18nTemplate } from './orderTypes';

export const orderUiHistoryTemplate: OrderLanguageMap<OrderI18nTemplate['ui']['history']> = {
  zh: {
    selectOrdersToExport: '请选择要导出的订单',
    noPackageDataToExport: '没有可导出的包裹信息',
    exportSuccessPrefix: '成功导出',
    exportSuccessSuffix: '个包裹信息',
    exportFailed: '批量导出失败，请稍后重试',
    unknownOperationPrefix: '未知操作',
    operationFailed: '操作失败',
    batchOperationFailed: '批量操作失败，请稍后重试',
    batchCancel: '批量取消',
    batchPay: '批量支付',
    batchRefund: '批量申请退款',
    batchExport: '批量导出',
    myOrders: '我的订单',
    myOrdersDescription: '查看和管理您的所有运单，追踪包裹状态，处理异常订单。',
    loginNow: '立即登录',
    allOrders: '全部订单',
    all: '全部',
    newestFirst: '新订单在前',
    oldestFirst: '旧订单在前',
    searchPlaceholder: '搜索订单号、快递单号、收件人...',
    selectAll: '全选',
    orderDateFilter: '订单时间筛选',
    orderItemType: '订单',
    noOrdersYet: '暂无订单',
    placeOrderNow: '立即下单',
    noOrdersMatch: '没有找到符合条件的订单',
    previous: '上一页',
    next: '下一页',
    csvHeaders: [
      '订单号',
      '收件人',
      '运单号',
      '费用',
      '状态',
      '错误信息',
      '面单创建日期',
      '预计送达时间',
      '包裹长度',
      '包裹宽度',
      '包裹高度',
      '重量',
      '街道',
      '城市',
      '州',
      '邮编',
      '国家',
      '快递公司',
      '服务类型',
    ],
    batchCancelSucceeded: '批量取消成功',
    batchPaymentSucceeded: '批量支付成功',
    batchRefundSucceeded: '批量退款申请成功',
    batchCancelFailed: '批量取消失败',
    batchPaymentFailed: '批量支付失败',
    batchRefundFailed: '批量退款申请失败',
    batchCancelPartialSuffix: '个订单取消成功',
    batchPaymentPartialSuffix: '个订单支付成功',
    batchRefundPartialSuffix: '个订单退款申请成功',
  },
  en: {
    selectOrdersToExport: 'Please select orders to export',
    noPackageDataToExport: 'No package data available to export',
    exportSuccessPrefix: 'Exported',
    exportSuccessSuffix: 'package records',
    exportFailed: 'Batch export failed. Please try again.',
    unknownOperationPrefix: 'Unknown operation',
    operationFailed: 'Operation failed',
    batchOperationFailed: 'Batch operation failed. Please try again.',
    batchCancel: 'Batch Cancel',
    batchPay: 'Batch Pay',
    batchRefund: 'Batch Refund',
    batchExport: 'Batch Export',
    myOrders: 'My Orders',
    myOrdersDescription: 'View and manage all your labels, track package statuses, and resolve exceptions.',
    loginNow: 'Login Now',
    allOrders: 'All Orders',
    all: 'All',
    newestFirst: 'Newest First',
    oldestFirst: 'Oldest First',
    searchPlaceholder: 'Search order number, tracking number, recipient...',
    selectAll: 'Select All',
    orderDateFilter: 'Order Date Filter',
    orderItemType: 'Order',
    noOrdersYet: 'No Orders Yet',
    placeOrderNow: 'Place Order',
    noOrdersMatch: 'No orders match your filters',
    previous: 'Previous',
    next: 'Next',
    csvHeaders: [
      'Order Number',
      'Recipient',
      'Tracking Number',
      'Cost',
      'Status',
      'Error Message',
      'Label Created Date',
      'Estimated Delivery Time',
      'Package Length',
      'Package Width',
      'Package Height',
      'Weight',
      'Street',
      'City',
      'State',
      'Zipcode',
      'Country',
      'Carrier',
      'Service Type',
    ],
    batchCancelSucceeded: 'Batch cancel succeeded',
    batchPaymentSucceeded: 'Batch payment succeeded',
    batchRefundSucceeded: 'Batch refund succeeded',
    batchCancelFailed: 'Batch cancel failed',
    batchPaymentFailed: 'Batch payment failed',
    batchRefundFailed: 'Batch refund failed',
    batchCancelPartialSuffix: 'orders cancelled successfully',
    batchPaymentPartialSuffix: 'orders paid successfully',
    batchRefundPartialSuffix: 'orders refund requested successfully',
  },
};
